import type { FC } from 'react'

import { LoaderCircle } from '@skytech/ui'
import { Container } from '@skytech/ui/Container'
import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { getStatusName } from '@/modules/ecom-policy/helpers'
import ecomPolicyResources from '@/modules/ecom-policy/resources'
import { APP_ROUTES } from '@/util/app-routes'

import queries from '../queries'

import EcomPolicyOrderDetails from './EcomPolicyOrderDetails'
import EcomPolicyOrderOptions from './EcomPolicyOrderOptions'
import EcomPolicyOrderProducts from './EcomPolicyOrderProducts'
import EcomPolicyOrderUser from './EcomPolicyOrderUser'

import './index.styles.scss'

const EcomPolicyOrder: FC = () => {
  const navigate = useNavigate()
  const { ecomPolicyOrderId } = useParams()

  if (!ecomPolicyOrderId) navigate(APP_ROUTES.HARDWARE_ECOM_POLICY_ORDER_LIST)

  const { data: order, isLoading } = useQuery(queries.order(Number(ecomPolicyOrderId)), () =>
    ecomPolicyResources.getOrder(Number(ecomPolicyOrderId))
  )

  if (isLoading) return <LoaderCircle />
  if (!order) return null

  return (
    <Container className="ecom-policy-order">
      {ecomPolicyOrderId && (
        <Container.Header>
          <Translation
            id="Ecom Policy Order {ecomPolicyOrderId}"
            ecomPolicyOrderId={ecomPolicyOrderId}
          />
        </Container.Header>
      )}
      <h3>
        <Translation id={`ecom_order_status/${getStatusName(order.statusId)}`} />
      </h3>
      <EcomPolicyOrderOptions />
      <div className="sections">
        <EcomPolicyOrderUser order={order} />
        <EcomPolicyOrderDetails order={order} />
        <EcomPolicyOrderProducts order={order} />
      </div>
    </Container>
  )
}

export default EcomPolicyOrder
